export const REQUEST_TYPES = 'dt/types/REQUEST_TYPES';
export const RECEIVED_TYPES = 'dt/types/RECEIVED_TYPES';

export const requestTypes = (siteId) => ({
  type: REQUEST_TYPES,
  query: { site: siteId },
});

export const receiveTypes = (types) => ({
  type: RECEIVED_TYPES,
  types,
});
